export class mdlCheckPromoCodeRes {
    public PromoId: string;
    public PromoCode: string;
    public PromoDiscountType: string;
    public PromoResult: string;
    public PromoDiscPer: number;
    public PromoDiscFlatAmount: string;
    public StatusCode: string;
    public ErrorMsg: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlCheckPromoCodeRes.ts